"use client";
import { useEffect as r } from "react";
const c = (e, n) => {
  r(() => {
    const t = (o) => {
      e.current && !e.current.contains(o.target) && n();
    };
    return document.addEventListener("mousedown", t), () => {
      document.removeEventListener("mousedown", t);
    };
  }, [e]);
};
export {
  c as useOutsideRefClickCallback
};
//# sourceMappingURL=index.es468.js.map
